angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "FORM_PHOTO": {
    "ERROR": {
      "DEFAULT": "Upload failed. Check your internet connection.",
      "DIMENSIONS": "Minimum photo size is 320x320 pixels.",
      "FORMAT": "Invalid image format. Upload .jpg or .png image."
    }
  }
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/nls/form_photo.json
// module id = 85
// module chunks = 24